import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Auth.scss";
import { AuthPageHeader } from "./AuthPageHeader";
import { useHttpClient } from "../../hooks/useHttpClient";
import { useUserContext } from "../../stores/userContext";
import { useLocalization } from "../../stores/localizationContext";

/** Parse axios/API error payload for send-otp (supports numeric or string error_id). */

export const SigninEmail = ({
    title,
}: {
    title?: string;
}) => {
    const { t, lang } = useLocalization();
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const { logout } = useUserContext();
    const navigate = useNavigate();
    const api = useHttpClient(false); // No token needed for sign-in

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmailValid = emailRegex.test(email);

    useEffect(() => {
        logout();
    }, []);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        // Clear previous error
        setError("");

        // Validate email again before submitting
        if (!emailRegex.test(email)) {
            setError(t("this_email_doesnot_exist_error_message"));
            return;
        }

        setIsLoading(true);

        try {
            const endpoint = import.meta.env.VITE_SEND_OTP;

            const response = await api.post(endpoint, { email, language: lang });

            if (response.status === 200 || response.status === 201) {
                // Success - navigate to OTP verification page
                navigate(`/${lang}/verifyemailotp`, { state: { email, duration: response.data.duration, resendingDuration: response.data.resending_duration } });
            }
        } catch (err: any) {
            // Handle error
            if (err.response?.data?.error_id === 4003) {
                setError(t("this_email_doesnot_exist_error_message"));
            } else if (err.response?.data?.error_id === 4292) {
                setError(t("otp_limit_exceeded_error"));
            } else {
                setError(t("this_email_doesnot_exist_error_message"));
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="auth-container">
                <AuthPageHeader title={title ?? t("continue_with_email_label")} />
                <div className="auth-page">
                    
                    <div className="form-wrapper">
                        <div className="form-wrapper__fields">
                            <div className="form-wrapper__fields__input">

                                <input
                                    className="input"
                                    type="text"
                                    name="email"
                                    placeholder={t("email_address_placeholder_label")}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    disabled={isLoading}
                                    autoComplete="email"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="actions">
                        <button
                            className={`btn btn-primary${!isEmailValid || isLoading ? " disabled" : ""}`}
                            disabled={!isEmailValid || isLoading}
                            onClick={handleSubmit}
                        >
                            {t("continue_button")}
                        </button>
                    </div>
                    {error && (
                        <div id="message" className="error-message">
                            {error}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};
